// extracted by css-extract-rspack-plugin
export default {"breadcrumb":"cbENQ7mlqt8Jz352","description":"qEcN6FqRFMe3q2FL"};